<template lang="pug">
    v-menu(dense v-model="timebox" :close-on-content-click="false")
        template(v-slot:activator="{ on }")
            v-text-field(dense readonly :value="formatTime" v-on="readonly ? '' : on" :label="label" append-icon="alarm" )
        v-time-picker(dense v-model="time" @change="onSelect" format="24hr" use-seconds)
</template>
<script>
export default {
    name: "FTimebox",
    props: ["value", "readonly", "label"],
    data() {
        return {
            time : null,
            timebox: false
        };
    },
    mounted(){
        this.tim = this.value;
    },
    watch: {
        value(val) {
            this.time = val;
        }
    },
    computed: {
        formatTime() {
            return this.time;
        },
    },
    methods: {
        onSelect() {
            this.$emit("input", this.time);
            this.$emit("select", this.time);
            this.$emit("change", this.time);
            this.timebox = false;
        },
    },
}
</script>
